module.exports = __webpack_public_path__ + "museosans500-webfont.b5abef5b9cf5286f95f8.woff2";


//////////////////
// WEBPACK FOOTER
// D:/api-fronted/css/fonts/museosans500-webfont.woff2
// module id = ../../../../../css/fonts/museosans500-webfont.woff2
// module chunks = styles